import { packingSlipSchema } from "@redotech/redo-model/packing-slips/packing-slip-definition";

export const updatePackingSlipTemplate = {
  name: "updatePackingSlipTemplate" as const,
  input: packingSlipSchema,
  output: packingSlipSchema,
};
